import { makeAutoObservable } from "mobx";
import { createContext } from "react";
import { AccountRole, AccountType } from "types/account";

export class Account {
  value: AccountType = localStorage.getItem('account')? JSON.parse(localStorage.getItem('account')): null

  constructor () {
    if(this.value){
      localStorage.setItem('account', JSON.stringify(this.value))
    }
    makeAutoObservable(this)
  }
  async setAccount (newValue:Partial<AccountType>) {
    const value = {...this.value, ...newValue}
    localStorage.setItem('account', JSON.stringify(value));
    this.value = value;
    return newValue
  }
  async clearAccount () {
    localStorage.removeItem('account')
    localStorage.removeItem('sidebarChannels')
    this.value = null;
  }
  getToken() {
    return (this.value)?.secretKey||null
  }

  setCredit(number: number) {
    console.log(number)
    this.setAccount({paidCredit: number})
    
    // const newValue  = {...this.value, paidCredit: number}
    // localStorage.setItem('account', JSON.stringify(newValue))
    // this.value = newValue
  }
  getRole():AccountRole{
    return (this.value)?.role || null
  }
  
  checkPremission(roles:AccountRole[]): boolean {
    return this.value.role && roles.includes(this.value.role)
  }
}

export const AccountContext = createContext<Account>(new Account())


